import * as React from "react";
import { FileUploadInput } from "kw/util/Question/inputs/FileUploadInput";
import { parseQueryString } from "kanopi-components/utils/browser";
import { QuestionFlowTypeKey } from "kw/components/QuestionFlow/QuestionFlowComponent";
import { quoteFlowFields } from "kw/api/fragments";
import { SidePadder } from "kanopi-components/Layout";
import { useNavigate } from "@reach/router";
import { useStartQuestionFlow } from "kw/hooks/useStartQuestionFlow";

export const AutoUpdate = () => {
  const [uploadingText, setUploadingText] = React.useState("Uploading...");

  const params = parseQueryString({ search: location?.search });
  const startPolicyUpdateQuery = (autoQuote = false) => ({
    startPolicyUpdate: [
      {
        input: {
          policyId: params?.policyId,
          flow: "details",
          create: false,
          autoQuote,
        },
      },
      {
        ...quoteFlowFields,
      },
    ],
  });
  const { startQuestionFlow } = useStartQuestionFlow({
    mutationQuery: startPolicyUpdateQuery(),
    globalDataKey: QuestionFlowTypeKey.update,
    questionFlowResponseKey: "startPolicyUpdate",
  });
  // const [, riskProfile, { priceRiskProfile, priceLoading, initialPriceLoading }] =
  //   usePriceRiskProfile();
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const onFileUpload = () => {
    setLoading(true);
    setTimeout(() => {
      setUploadingText("Processing Quote slip...");
    }, 3000);
    setTimeout(() => {
      setUploadingText("Preparing the quote...");
    }, 8000);
    startQuestionFlow(startPolicyUpdateQuery(), () => {
      setLoading(false);
      // setInitialLoading(false);
      navigate(`/policies/${params?.policyId}/update/details`);
    });
  };
  return (
    <SidePadder padding="flow">
      <FileUploadInput
        onChange={onFileUpload}
        uploading={loading}
        uploadingText={uploadingText}
        // file={file}
      />
    </SidePadder>
  );
};
